import { SVG } from './esveegee.js'

import { Colors } from './colors.js'

export const timeline = (s: SVG) => {
    const blockSize = { width: 25, height: 25 }

    const steps = [
        { start: 0, duration: 3, label: 'task #1' },
        { start: 2, duration: 4, label: 'task #2' },
        { start: 3, duration: 6, label: 'task #3' },
    ]

    const current = 3

    // bars
    for (const [index, step] of steps.entries()) {
        s.group(16 + step.start * blockSize.width, 16 + index * blockSize.height)
            .draggable()
            .rect(0, 0, step.duration * blockSize.width, blockSize.height)
            .fill(step.duration > current ? Colors.SeaBlue : Colors.SeaBlueLight)
            .stroke()
            .text(step.label, 16, blockSize.height / 2)
            .verticalAlign('middle')
            .fill('white')
    }

    // current
    s.line(16 + current * blockSize.width, 0, 16 + current * blockSize.width, (steps.length + 2) * blockSize.height)
        .stroke('#00d400').draggable()
}
